import { EDIT_MODE } from '../../../../constant/Safety/Common/mode';
import SAFETY_TRUCK_MODAL_DEFAULT_VALUE from '../../../../constant/Safety/Truck/Modal/defaultValue';

const createModalDefaultValue = ({ specificData, editMode }) => {
  if (editMode === EDIT_MODE?.add)
    return { ...SAFETY_TRUCK_MODAL_DEFAULT_VALUE };

  if (specificData) {
    const specificDefaultData = {
      div: specificData?.div || '',
      truck_no: specificData?.truck_no || '',
      truck_make: specificData?.truck_make || '',
      truck_model: specificData?.truck_model || '',
      make_year: specificData?.make_year,
      vin_no: specificData?.vin_no || '',
      plate_no: specificData?.plate_no || '',
      state: specificData?.state || '',
      status: specificData?.status || '',
      emodal: specificData?.emodal || '',
      ctp: specificData?.ctp || '',
      ctp_exp: specificData?.ctp_exp || null,
      pdtr: specificData?.pdtr || null,
      rfid: specificData?.rfid || '',
      bank: specificData?.bank || '',
      purchase_amt: specificData?.purchase_amt || '',
      total_loan_amt: specificData?.total_loan_amt || '',
      sche_payment: specificData?.sche_payment || '',
      interest_rate: specificData?.interest_rate,
      loan_terms: specificData?.loan_terms,
      loan_status: specificData?.loan_status || '',
      loan_start_date: specificData?.loan_start_date || null,
      loan_end_date: specificData?.loan_end_date || null,
      extra_payment: specificData?.extra_payment || '',
      depreciation_amt: specificData?.depreciation_amt || '',
      depreciation_start_date: specificData?.depreciation_end_date || null,
      depreciation_end_date: specificData?.depreciation_end_date || null,
      depreciable_life: specificData?.depreciable_life,
      depreciation_status: specificData?.depreciation_status || '',
      remarks: specificData?.remarks || '',
      active: specificData?.active,
      created_by: specificData?.created_by || '',
      created_date: specificData?.created_date || null,
      updated_by: specificData?.updated_by || '',
      updated_date: specificData?.updated_date || null,
      driver: specificData?.driver || '',
      doc: [
        {
          updated_date: null,
          document: '',
          exp_date: null,
          file_url: null,
          updated_by: '',
        },
        ...specificData?.doc,
      ],
    };

    return specificDefaultData;
  }

  return { ...SAFETY_TRUCK_MODAL_DEFAULT_VALUE };
};

export default createModalDefaultValue;
